import type { SalonFeaturesType } from "@/contexts/FeaturesContext";

export type MenuStaffRole = "admin" | "funcionario" | "caixa" | "recepcionista";

export type AccessControlledMenuItem = {
  label: string;
  path: string;
  roles: MenuStaffRole[];
  featureKey?: keyof SalonFeaturesType;
};

const moduleByPath: Record<string, string> = {
  "/appointments": "agenda",
  "/weekly-calendar": "agenda",
  "/checkout": "caixa",
  "/clients": "clientes",
  "/services": "servicos",
  "/products": "produtos",
  "/reports": "relatorios",
  "/staff": "equipe",
  "/settings": "configuracoes",
  "/promotions": "promocoes",
  "/commissions": "comissoes",
  "/my-commissions": "comissoes",
  "/professionals": "profissionais",
  "/branches": "filiais",
  "/reviews": "avaliacoes",
  "/packages": "pacotes",
};

export function resolveMenuAccess<T extends AccessControlledMenuItem>(
  items: T[],
  staffRole: MenuStaffRole,
  effectiveModules: string[] | undefined,
  hasFeature: (key: keyof SalonFeaturesType) => boolean,
) {
  return items
    .filter(item => {
      if (!item.roles.includes(staffRole)) return false;
      if (staffRole === "admin") return true;
      const moduleKey = moduleByPath[item.path];
      return !moduleKey || !effectiveModules || effectiveModules.includes(moduleKey);
    })
    .map(item => ({
      item,
      isLocked: Boolean(item.featureKey && !hasFeature(item.featureKey)),
    }));
}
